const icons = {};

icons.example = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="24" height="24" fill="white" />
  <path fill-rule="evenodd" clip-rule="evenodd" d="M21 4.49999L3 4.5L3 3.00001L21 3L21 4.49999Z" fill="#1679F9" />
  <path fill-rule="evenodd" clip-rule="evenodd" d="M10 11L7 11L7 9.50001L10 9.5L10 11Z" fill="#1679F9" />
  <path fill-rule="evenodd" clip-rule="evenodd" d="M14 14.5L17 14.5L17 13L14 13L14 14.5Z" fill="#1679F9" />
  <path fill-rule="evenodd" clip-rule="evenodd" d="M17 11L12 11L12 9.50001L17 9.5L17 11Z" fill="#1679F9" />
  <path fill-rule="evenodd" clip-rule="evenodd" d="M7 14.5L12 14.5L12 13L7 13L7 14.5Z" fill="#1679F9" />
  <path fill-rule="evenodd" clip-rule="evenodd" d="M21 21L3 21L3 19.5L21 19.5L21 21Z" fill="#1679F9" />
</svg>


export default icons;